let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hn34F")).then(() => parcelRequire('grb79'));